import { Link } from 'react-router-dom';
import { categories, navLinks, siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full bg-primary-950 text-background-100">
      <div className="container-page grid grid-cols-1 gap-10 py-12 md:grid-cols-2 lg:grid-cols-4 lg:py-16">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-primary-950">
              爆
            </span>
            <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.description}</p>
          <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line" aria-hidden="true" />
            </span>
            <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-primary-300">
              {siteInfo.email}
            </a>
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="#footer-nav" className="transition-colors hover:text-primary-300">
              快捷导航
            </a>
          </h4>
          <ul id="footer-nav" className="mt-4 flex flex-col gap-3 text-sm">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-background-200 transition-colors hover:text-primary-300">
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/schedule#subscribe" className="text-background-200 transition-colors hover:text-primary-300">
                直播预告提醒
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="#footer-cats" className="transition-colors hover:text-primary-300">
              直播栏目
            </a>
          </h4>
          <ul id="footer-cats" className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
            {categories.map((item) => (
              <li key={item.key}>
                <Link to="/schedule" className="text-background-200 transition-colors hover:text-primary-300">
                  {item.key}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
            <a href="#footer-about" className="transition-colors hover:text-primary-300">
              关于本站
            </a>
          </h4>
          <div id="footer-about" className="mt-4 flex flex-col gap-3 text-sm text-background-200">
            <p>服务时间：{siteInfo.workTime}</p>
            <p>{siteInfo.updateNote}</p>
            <Link
              to="/about"
              className="mt-1 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700/60 px-3.5 py-2 text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
            >
              了解内容原则
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-5 text-xs text-background-300 sm:flex-row">
          <p>© {year} {siteInfo.name} · 仅整理与呈现公开直播排期信息</p>
          <p>本站不提供直播推流服务，具体开播时间以主播通知为准</p>
        </div>
      </div>
    </footer>
  );
}